import { Injectable, inject } from '@angular/core';
import { UiRefreshService } from '@common/ui-refresh.service';

/**
 * @name DashboardBSCServiceService
 * @desc Servicio que se usa para todo lo referente a los dashboards de BSC
 */

// const HTTP_TIMEOUT = 300000;
const HTTP_TIMEOUT = 150000;

@Injectable({
    providedIn: 'root'
})
export class ChatAIPopupService {
    // Zoneless: fetch no pasa por HttpClient (interceptor); quien espera la respuesta cambia el estado
    private uiRefresh = inject(UiRefreshService);

    async getSendMessage(lamdaMainURL: string, lamdaAPIKey: string, strMensagge: string, chartsEnabled: boolean, sessionId: string, quantumSessionToken: string, executionId: string) {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), HTTP_TIMEOUT);

        try {
            const respBody = {
                execution_id: executionId,
                question: strMensagge,
                generate_charts: chartsEnabled,
                session_id: sessionId,
                user_email: "admin@sunustech.com",
                quantum_token: quantumSessionToken
            };

            const response = await fetch(lamdaMainURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': lamdaAPIKey,
                },
                body: JSON.stringify(respBody),
                signal: controller.signal,
            });

            if (!response.ok) {
                const errorText = await response.json();
                // throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
                return errorText;
            }

            const responseData = await response.json();
            // console.log('Response:', responseData);
            return responseData;
        } catch (error) {

            if (error.name === 'AbortError') {
                console.log('Fetch request aborted by user or system.');
                // Handle the abortion gracefully, e.g., display a message, clean up resources
                const errorText = { error: 'El servidor no respondió dentro del tiempo esperado. Es posible que el servicio esté experimentando alta demanda o problemas de conectividad.' };
                return errorText;
            } else {
                // Handle other types of errors
                console.error('An unexpected error occurred:', error);
                throw error;
            }
        } finally {
            clearTimeout(timeoutId);
            this.uiRefresh.notify();
        }
    }
}
